import { render } from "./NoData.vue?vue&type=template&id=5da228cc&scoped=true&ts=true"
import script from "./NoData.vue?vue&type=script&lang=ts"
export * from "./NoData.vue?vue&type=script&lang=ts"

import "./NoData.vue?vue&type=style&index=0&id=5da228cc&lang=stylus&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5da228cc"]])

export default __exports__